import { render, staticRenderFns } from "./OpluxDialog.vue?vue&type=template&id=c2b94c34&scoped=true&"
import script from "./OpluxDialog.vue?vue&type=script&lang=js&"
export * from "./OpluxDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpluxDialog.vue?vue&type=style&index=0&id=c2b94c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b94c34",
  null
  
)

export default component.exports